module.exports = __webpack_public_path__ + "d308073b/img/copy-icon.408fdb2d.svg";